export default __webpack_public_path__ + "locales/dnevnik.kk.json";